import { DEFAULT_PRODUCT_ORIGIN_URL } from './constants'

/*
  Add media-query classes into html as a class:
    < 768 --> media-xs
    768 - 991 --> media-sm
    992 - 1599 --> media-md
    > 1600 --> media-lg
*/
export const mediaXs = 768
export const mediaSm = 992
export const mediaMd = 1600
export const mediaLg = 1600

export const getApiBaseUrl = (value, appCode) => {
  switch (value) {
    case 'app.strongtie.com':
      return 'https://api.strongtie.com/gws'
    case 'app-staging.strongtie.com':
      return 'https://api-staging.strongtie.com/gws'
    case 'app-dev.mystrongtie.com':
      return 'https://app-dev.mystrongtie.com/gws'
    case 'dvrapiqas01':
    case 'dvrapiqas01.simpsonmfg.com':
      return 'http://dvrapiqas01.simpsonmfg.com:8080/gws'
    case 'dvrjutldev':
    case 'dvrjutldev.simpsonmfg.com':
      if (appCode === 'PBS') {
        return 'https://api-staging.strongtie.com/gws'
      } else {
        return 'https://api-dev.mystrongtie.com/gws'
      }
    default:
      return 'https://api-staging.strongtie.com/gws'
    // if (appCode === 'PBS') {
    //   return 'https://api-staging.strongtie.com/gws'
    // } else {
    //   return 'https://api-dev.mystrongtie.com/gws'
    // }
  }
}

export const getReCaptchaSitekey = (value) => {
  switch (value) {
    case 'app.strongtie.com':
    case 'app-staging.strongtie.com':
    case 'app-dev.mystrongtie.com':
    case 'fd-blueprint-dev-hsbyajgacuhbaugt.a01.azurefd.net':
    case 'fd-blueprint-stage-dtewhpbyescteefu.a02.azurefd.net':
    case 'fd-blueprint-prod-efdqhwcycxgggpbh.a03.azurefd.net':
      // Support for all sub-domain of *.strongtie.com
      // secret key 6LeZocEUAAAAAEiNNqT-VMr9nlJAuVY6371cH8FL for strongtie.com
      return '6LeZocEUAAAAAGAtGJxAHqbEkKVm97r4-teJnQaV'
    case 'dvrapiqas01':
    case 'dvrapiqas01.simpsonmfg.com':
      // secret key 6Lev0O8UAAAAACY3K0tIWJQ-sJX1SyPQxSR_hY11 for dvrapiqas01
      return '6Lev0O8UAAAAAKg1E5XuOi0KQsucTwdwJFfoS-6J'
    default:
      // secret key 6Lev0O8UAAAAACY3K0tIWJQ-sJX1SyPQxSR_hY11 for dvrapiqas01
      return '6Lev0O8UAAAAAKg1E5XuOi0KQsucTwdwJFfoS-6J'
  }
}

export const getSmartsheetUrl = (value, appId) => {
  switch (value) {
    case 'app.strongtie.com':
      return 'https://api.strongtie.com/gws/smartsheet/v2/?app-id=' + appId
    case 'app-staging.strongtie.com':
      return 'https://api-staging.strongtie.com/gws/smartsheet/v2/?app-id=' + appId
    case 'app-dev.mystrongtie.com':
      return 'https://api-staging.strongtie.com/gws/smartsheet/v2/?app-id=' + appId
    case 'dvrapiqas01':
    case 'dvrapiqas01.simpsonmfg.com':
      return 'http://dvrapiqas01.simpsonmfg.com:8080/gws/smartsheet/v2/?app-id=' + appId
    case 'dvrjutldev':
    case 'dvrjutldev.simpsonmfg.com':
      return 'http://dvrjutldev.simpsonmfg.com:8080/gws/smartsheet/v2/?app-id=' + appId
    default:
      return 'https://api-staging.strongtie.com/gws/smartsheet/v2/?app-id=' + appId
  }
}

export const getPimBaseUrl = (value) => {
  switch (value) {
    case 'app.strongtie.com':
      return 'https://www.strongtie.com'
    case 'app-staging.strongtie.com':
      return 'https://www.strongtie.com'
    case 'dvrapiqas01':
      return 'https://www.strongtie.com' // 'https://qa2.sstpim.com'
    case 'dvrjutldev':
    case 'app-dev.mystrongtie.com':
      return 'https://www.strongtie.com' // 'https://qa2.sstpim.com'
    default:
      return 'https://www.strongtie.com'
  }
}

export const getECInterfaceDomain = (value) => {
  switch (value) {
    case 'app.strongtie.com':
      return 'https://customer.strongtie.com'
    case 'app-staging.strongtie.com':
      return 'https://customer.strongtie.com'
    case 'dvrapiqas01':
    case 'dvrapiqas01.simpsonmfg.com':
      return 'https://s2-ordering.strongtie.com'
    case 'dvrjutldev':
    case 'dvrjutldev.simpsonmfg.com':
    case 'app-dev.mystrongtie.com':
      return 'https://d2-ordering.strongtie.com'
    default:
      return 'https://sstb2b.local:9002'
  }
}

/**
 * Short Url - Individual Request Quote
 * @example
 * getBaseUrlForRequestQuote("app-staging.strongtie.com", "agpd")
 * @returns https://app-staging.strongtie.com/agpd?data=%7B%22input%22%3A%7B%22truss%22%3A%7B%22style%22%3A%22fan%22%2C%22plateOptions%22%3A%22nonSpecPlate%22%2C%22gablePlate%22%3A%22APGP1212%22%2C%22topChord%22%3A%226x6%22%2C%22bottomChord%22%3A%226x6%22%2C%22web%22%3A%226x6%22%2C%22topChordSlope%22%3A8%2C%22bottomChordSlope%22%3A0%2C%22webAngleFromVertical%22%3A45%2C%22webAngleFromVertical2%22%3A90%2C%22frameSpan%22%3A160%2C%22overhang%22%3A24%2C%22frameID%22%3A%22Frame%201%22%2C%22quantity%22%3A1%2C%22overhangCut%22%3A%22ogee%22%2C%22isAllPlatesSelected%22%3Afalse%2C%22isRough%22%3Afalse%7D%2C%22plate%22%3A%7B%22plateProfile%22%3A%22rustic%22%2C%22materialCoating%22%3A%22powderCoatedBlackZMAX%22%2C%22plateThickness%22%3A0.11%2C%22legWidth%22%3A5%2C%22legLength%22%3A5.5%2C%22plateOffset%22%3A0.25%2C%22includePlates%22%3Atrue%7D%2C%22fastener%22%3A%7B%22fastenerDiameter%22%3A2%2C%22fastenerQuantityPerLeg%22%3A6%2C%22fastenerNumberOfRows%22%3A2%2C%22fastenerColumnSpacing%22%3A2.875%2C%22fastenerEndDistance%22%3A0.875%2C%22fastenerEdgeDistance%22%3A1.25%2C%22fastenerOffset%22%3Atrue%7D%7D%2C%22output%22%3A%7B%22result%22%3A%7B%22searchKeyword%22%3A%22%22%2C%22optimized%22%3Afalse%2C%22sortBy%22%3A%7B%7D%7D%7D%7D
 */

export const getBaseUrlForRequestQuote = (value, appCode) => {
  switch (value) {
    case 'app.strongtie.com':
      return `https://app.strongtie.com/${appCode}`
    case 'app-staging.strongtie.com':
      return `https://app-staging.strongtie.com/${appCode}`
    case 'app-dev.mystrongtie.com':
      return `https://app-dev.mystrongtie.com/${appCode}`
    case 'dvrjutldev.simpsonmfg.com':
      return `dvrjutldev.simpsonmfg.com/${appCode}`
    default:
      return `http://localhost:8080/${appCode}.html`
  }
}

export const getProductOriginURL = () => {
  if (window.location !== window.parent.location) {
    const searchParams = new URLSearchParams(window.location.search)
    const sourceDomain = searchParams.get('sourceDomain')
    if (!sourceDomain) return DEFAULT_PRODUCT_ORIGIN_URL

    const url = decodeURIComponent(sourceDomain).split('?')[0]
    return url
  }

  return DEFAULT_PRODUCT_ORIGIN_URL
}
